'use strict';

module.exports = ['USD', 'GBP', 'EUR', 'CAD', 'AUD', 'CHF', 'MXN'];



//////////////////
// WEBPACK FOOTER
// ./~/dibs-contact-modal/~/dibs-currency-helpers/currencies.js
// module id = 2069
// module chunks = 62